import { LatestDriveTimesDto } from "../models/driveTime/driverDriveTimes";
import { ApiResponse, apiCall } from "./apiClient";

// Get driving time data for employee from common-api
export const getLatestDriveTimeInfoByEmployee = (
    employeeId: string
): Promise<ApiResponse<LatestDriveTimesDto>> => {
    return apiCall<LatestDriveTimesDto>("driver/latestDriveTimeInfoByEmployee?employeeId=" + (employeeId), "GET");
};